import { Injectable } from "@angular/core";
import { NgbDateAdapter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
    readonly DELIMITER = '/';

    fromModel(value: string | null): NgbDateStruct | null {
        if (value) {
            if (typeof value === 'string') {
                const date = new Date(value);
                return {
                    day: date.getDate(),
                    month: date.getMonth() + 1,
                    year: date.getFullYear(),
                };
            }
            return value;
        }
        return null;
    }

    toModel(date: NgbDateStruct | null): string | null {
        return date ? date.month + this.DELIMITER + date.day + this.DELIMITER + date.year : null;
    }
}